import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
const StripeContext = createContext(undefined);
export const useStripe = () => {
    const context = useContext(StripeContext);
    if (context === undefined) {
        throw new Error('useStripe must be used within a StripeProvider');
    }
    return context;
};
export const StripeProvider = ({ children }) => {
    const [stripePromise, setStripePromise] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        // Fetch the correct Stripe publishable key from backend
        const loadStripeConfig = async () => {
            try {
                const response = await fetch('/api/billing/stripe-config', {
                    credentials: 'include'
                });
                if (!response.ok) {
                    throw new Error('Failed to fetch Stripe configuration');
                }
                const config = await response.json();
                console.log('[StripeContext] Using Stripe key:', config.publishableKey.substring(0, 12) + '...');
                // Load Stripe with the correct key
                const stripe = loadStripe(config.publishableKey);
                setStripePromise(stripe);
            }
            catch (err) {
                console.error('[StripeContext] Failed to load Stripe config:', err);
                setError(err instanceof Error ? err.message : 'Failed to load Stripe');
            }
            finally {
                setIsLoading(false);
            }
        };
        loadStripeConfig();
    }, []);
    const value = {
        stripe: stripePromise,
        isLoading,
        error
    };
    // Show loading state while fetching Stripe config
    if (isLoading) {
        return (_jsx(StripeContext.Provider, { value: value, children: children }));
    }
    // Show error state if Stripe config failed to load
    if (error || !stripePromise) {
        return (_jsx(StripeContext.Provider, { value: value, children: children }));
    }
    return (_jsx(StripeContext.Provider, { value: value, children: _jsx(Elements, { stripe: stripePromise, children: children }) }));
};
